// @flow

import React from 'react';
import type { Yoast } from '../../../types/apiRoute';

export const metaTag = (name: string) => (
  (value: string, key: string) => (
    <meta name={name} content={value} key={key} />
  )
);

export const metaRobotsTag = (index: string, follow: string) => (
  <meta
    name="robots"
    content={`${index === '1' ? 'noindex' : 'index'}, ${follow === '1' ? 'nofollow' : 'follow'}`}
  />
);

export const yoastTagMapping = {
  yoast_wpseo_metadesc: metaTag('description'),
  yoast_wpseo_metakeywords: metaTag('keywords'),
  yoast_wpseo_canonical: (value: string, key: string) => <link rel="canonical" href={value} key={key} />,
  'yoast_wpseo_opengraph-title': metaTag('og:title'),
  'yoast_wpseo_opengraph-description': metaTag('og:description'),
  'yoast_wpseo_opengraph-image': metaTag('og:image'),
  'yoast_wpseo_twitter-title': metaTag('twitter:title'),
  'yoast_wpseo_twitter-description': metaTag('twitter:description'),
  'yoast_wpseo_twitter-image': metaTag('twitter:image'),
};

export default (data: $Shape<Yoast>): Array<string> => Object.entries(data)
  .filter(([key, value]) => yoastTagMapping[key] && value)
  .map(([key, value]) => yoastTagMapping[key](value, key));
